


























































































































































































































































import {
  Vue, Component, PropSync, Watch,
} from 'vue-property-decorator';

import InvestorProfileLevelExperienceViewModel
  from '@/vue-app/view-models/components/contract-savings/profiling/allianz-investor-profile/investor-profile-level-experience-view-model';

// Domain
import {
  OnBoardingStepEntity,
} from '@/modules/my-investment/on-boarding-steps/domain/entities/on-boarding-step-entity';
import {
  TemplateQuestionnaireEntity,
} from '@/modules/my-investment/catalogs/allianz/template-questionnaire/domain/entities/template-questionnaire-entity';

@Component({
  name: 'InvestorProfileLevelExperience',
  components: {
    ContractSavingsActions: () => import('@/vue-app/components/contract-savings/ContractSavingsActions.vue'),
  },
})

export default class InvestorProfileLevelExperience extends Vue {
  @PropSync('onboardingStep', { type: Object, required: true })
  private onboarding_step_synced!: OnBoardingStepEntity;

  @PropSync('questions', { type: Array, required: true, default: [] })
  private questions_synced!: Array<TemplateQuestionnaireEntity>;

  @PropSync('loadFinished', { type: Boolean, required: true, default: false })
  private load_finished_synced!: boolean;

  investor_experience_view_model = Vue.observable(
    new InvestorProfileLevelExperienceViewModel(this),
  );

  @Watch('load_finished_synced')
  onLoadFinishedChange(load_finished_synced: boolean) {
    this.investor_experience_view_model.chargeOnLoadFinished(
      load_finished_synced, this.questions_synced, this.onboarding_step_synced,
    );
  }

  mounted() {
    if (this.load_finished_synced) {
      this.investor_experience_view_model.chargeOnLoadFinished(
        this.load_finished_synced, this.questions_synced, this.onboarding_step_synced,
      );
    }
  }

  async created() {
    await this.investor_experience_view_model.initialize();
  }
}

